var _g, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 552,
    height: 516.67004,
    viewBox: "0 0 552 516.67004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M383.99999,516.67004h-216c-4.41828,0-8-3.58172-8-8V8c0-4.41828,3.58172-8,8-8h216c4.41828,0,8,3.58172,8,8v500.67004c0,4.41828-3.58172,8-8,8Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.99999,24h-216c-1.10457,0-2-.89543-2-2s.89543-2,2-2h216c1.10457,0,2,.89543,2,2s-.89543,2-2,2Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276,
    cy: 11,
    r: 4,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.01897,470.89001h-216.0379c-1.10457,0-2-.89543-2-2s.89543-2,2-2h216.0379c1.10457,0,2,.89543,2,2s-.89543,2-2,2Z",
    fill: "#3f3d56"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M276,231.67004c-24.81299,0-45-20.18701-45-45s20.18701-45,45-45,45,20.18701,45,45-20.18701,45-45,45Zm0-88c-23.70996,0-43,19.29004-43,43s19.29004,43,43,43,43-19.29004,43-43-19.29004-43-43-43Z",
    fill: "#506fd9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M297.60844,179.14499c-1.66897,0-3.33801-.63599-4.60999-1.90802l-43.21002-43.20996c-2.54297-2.54303-2.54297-6.67603,0-9.21997,2.54303-2.54401,6.67603-2.54401,9.21997,0l43.21002,43.20996c2.54297,2.54303,2.54297,6.67603,0,9.21997-1.27197,1.27203-2.94098,1.90802-4.60999,1.90802Z",
    fill: "#506fd9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M254.39156,179.14499c-1.66901,0-3.33801-.63599-4.60999-1.90802-2.54297-2.54395-2.54297-6.67694,0-9.21997l43.21002-43.20996c2.54395-2.54401,6.67694-2.54401,9.21997,0,2.54297,2.54395,2.54297,6.67694,0,9.21997l-43.21002,43.20996c-1.27197,1.27203-2.94098,1.90802-4.60999,1.90802Z",
    fill: "#506fd9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M276,368.67004c-24.81299,0-45-20.18701-45-45s20.18701-45,45-45,45,20.18701,45,45-20.18701,45-45,45Zm0-88c-23.70996,0-43,19.29004-43,43s19.29004,43,43,43,43-19.29004,43-43-19.29004-43-43-43Z",
    fill: "#506fd9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M276,346.17004c-12.40698,0-22.5-10.09302-22.5-22.5s10.09302-22.5,22.5-22.5,22.5,10.09302,22.5,22.5-10.09302,22.5-22.5,22.5Zm0-43c-11.30396,0-20.5,9.19604-20.5,20.5s9.19604,20.5,20.5,20.5,20.5-9.19604,20.5-20.5-9.19604-20.5-20.5-20.5Z",
    fill: "#506fd9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M276,334.67004c-6.06152,0-11-4.93848-11-11s4.93848-11,11-11,11,4.93848,11,11-4.93848,11-11,11Zm0-20c-4.95947,0-9,4.04053-9,9s4.04053,9,9,9,9-4.04053,9-9-4.04053-9-9-9Z",
    fill: "#506fd9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPassword);
export default __webpack_public_path__ + "static/media/reset_password.ff2427b92268f83bfa5f6f50059102e7.svg";
export { ForwardRef as ReactComponent };